export default {
  consumer: state => state.consumer,
  preferredContact: getters => getters.consumer.preferredContact,
  preferredContactType: getters => {
    const { consumer } = getters;
    const { email, mobile, preferredContact } = consumer;
    return preferredContact === email ? 'email' : preferredContact === mobile ? 'mobile' : '';
  }
};
